import { useEffect } from 'react';

import redirect from 'js/lib/coursera.redirect';
import { useParams } from 'js/lib/useRouter';

import { useDegreePlanPropertiesContext } from 'bundles/degree-home/components/v3-dpm/context/DegreePlanPropertiesContext';
import constants from 'bundles/premium-certificate/constants/constants';

export type toOrFrom = 'to' | 'from';
/** @private */
export const useV3Redirector = (redirectDirection: toOrFrom, degreeAppPath: string) => {
  const { degreeSlug } = useParams();
  const { isDPMEnabled } = useDegreePlanPropertiesContext();

  useEffect(() => {
    if (!degreeSlug || isDPMEnabled === undefined) {
      return;
    }

    const conditionsForRedirection =
      (!isDPMEnabled && redirectDirection === 'from') || (isDPMEnabled && redirectDirection === 'to');

    if (conditionsForRedirection) {
      const basePath = `/${constants.degreeUrlRoot}/${degreeSlug}/`;
      redirect.setLocation(`${basePath}${degreeAppPath}`);
    }
  }, [degreeAppPath, degreeSlug, redirectDirection, isDPMEnabled]);
};

/** Redirect to an appropriate location if the user **is** part of the DPM / Degree V3 experiment */
export const useRedirectIfV3 = (degreeAppPath: string) => useV3Redirector('to', degreeAppPath);

/** Redirect to an appropriate location if the user **is not** part of the DPM / Degree V3 experiment */
export const useRedirectIfNotV3 = (degreeAppPath: string) => useV3Redirector('from', degreeAppPath);
